import { Type } from '@angular/core';
import { GameId } from 'src/app/model/game/game-id';
import { BlocksTutorialComponent } from './blocks-tutorial.component';
import { BlackjackTutorialComponent } from './blackjack-tutorial.component';
import { MarblesTutorialComponent } from './marbles-tutorial.component';
import { SolitaireTutorialComponent } from './solitaire-tutorial.component';
import { GameTutorial } from './game-tutorial';
import { TwentyOneTutorialComponent } from './twentyone-tutorial.component';
import { SlotsTutorialComponent } from './slots-tutorial.component';
import { PlinkoTutorialComponent } from './plinko-tutorial.component';

export const GAME_TUTORIAL_COMPONENT_MAP: Partial<Record<GameId, Type<GameTutorial>>> = {
  [GameId.Blocks]: BlocksTutorialComponent,
  [GameId.Blackjack]: BlackjackTutorialComponent,
  [GameId.Marbles]: MarblesTutorialComponent,
  [GameId.Solitaire]: SolitaireTutorialComponent,
  [GameId.TwentyOne]: TwentyOneTutorialComponent,
  [GameId.Slots]: SlotsTutorialComponent,
  [GameId.Plinko]: PlinkoTutorialComponent,
  // TODO(videopoker): add tutorial component before release
  // TODO(hilo): add tutorial component before release
};
